import React from 'react';
import { Calendar, MapPin, Ticket, Download, CheckCircle, Clock, XCircle } from 'lucide-react';
import { mockRegistrations } from '../data/mockData.js';

const Dashboard = ({ events }) => {
  const registrations = mockRegistrations;
  
  const getEventById = (eventId) => events.find(event => event.id === eventId);
  
  const getStatusIcon = (status) => {
    switch (status) {
      case 'confirmed':
        return React.createElement(CheckCircle, { className: 'status-icon confirmed', size: 20 });
      case 'pending':
        return React.createElement(Clock, { className: 'status-icon pending', size: 20 });
      case 'cancelled':
        return React.createElement(XCircle, { className: 'status-icon cancelled', size: 20 });
      default:
        return null;
    }
  };

  const formatDate = (dateString) => {
    const date = new Date(dateString);
    return date.toLocaleDateString('en-US', { 
      month: 'short', 
      day: 'numeric', 
      year: 'numeric' 
    });
  };

  return React.createElement('div', { className: 'dashboard' },
    React.createElement('div', { className: 'dashboard-header' },
      React.createElement('h2', null, 'My Event Registrations'),
      React.createElement('p', null, 'Manage your upcoming events and download tickets')
    ),
    
    React.createElement('div', { className: 'dashboard-stats' },
      React.createElement('div', { className: 'stat-card' },
        React.createElement('div', { className: 'stat-icon' },
          React.createElement(Calendar, { size: 24 })
        ),
        React.createElement('div', { className: 'stat-content' },
          React.createElement('h3', null, registrations.length),
          React.createElement('p', null, 'Total Events')
        )
      ),
      
      React.createElement('div', { className: 'stat-card' },
        React.createElement('div', { className: 'stat-icon' },
          React.createElement(CheckCircle, { size: 24 })
        ),
        React.createElement('div', { className: 'stat-content' },
          React.createElement('h3', null, registrations.filter(r => r.status === 'confirmed').length),
          React.createElement('p', null, 'Confirmed')
        )
      ),
      
      React.createElement('div', { className: 'stat-card' },
        React.createElement('div', { className: 'stat-icon' },
          React.createElement(Clock, { size: 24 })
        ),
        React.createElement('div', { className: 'stat-content' },
          React.createElement('h3', null, registrations.filter(r => r.status === 'pending').length),
          React.createElement('p', null, 'Pending')
        )
      )
    ),
    
    React.createElement('div', { className: 'registrations-list' },
      registrations.map(registration => {
        const event = getEventById(registration.eventId);
        if (!event) return null;
        
        return React.createElement('div', { 
          key: registration.id, 
          className: 'registration-card' 
        },
          React.createElement('div', { className: 'registration-image' },
            React.createElement('img', { src: event.image, alt: event.title })
          ),
          
          React.createElement('div', { className: 'registration-content' },
            React.createElement('div', { className: 'registration-header' },
              React.createElement('h3', null, event.title),
              React.createElement('div', { className: 'registration-status' },
                getStatusIcon(registration.status),
                React.createElement('span', { 
                  className: `status-text ${registration.status}` 
                }, registration.status.charAt(0).toUpperCase() + registration.status.slice(1))
              )
            ),
            
            React.createElement('div', { className: 'registration-details' },
              React.createElement('div', { className: 'detail-item' },
                React.createElement(Calendar, { size: 16 }),
                React.createElement('span', null, `${formatDate(event.date)} at ${event.time}`)
              ),
              React.createElement('div', { className: 'detail-item' },
                React.createElement(MapPin, { size: 16 }),
                React.createElement('span', null, event.location)
              ),
              React.createElement('div', { className: 'detail-item' },
                React.createElement(Ticket, { size: 16 }),
                React.createElement('span', null, `Ticket: ${registration.ticketNumber}`)
              )
            ),
            
            React.createElement('div', { className: 'registration-meta' },
              React.createElement('span', null, `Registered on ${formatDate(registration.registrationDate)}`),
              React.createElement('span', null, `$${event.price}`)
            )
          ),
          
          React.createElement('div', { className: 'registration-actions' },
            React.createElement('button', { className: 'btn-outline' },
              React.createElement(Download, { size: 16 }),
              'Download Ticket'
            ),
            React.createElement('button', { className: 'btn-secondary' }, 'View Event')
          )
        );
      })
    ),
    
    registrations.length === 0 &&
      React.createElement('div', { className: 'empty-state' },
        React.createElement(Calendar, { size: 64 }),
        React.createElement('h3', null, 'No Registrations Yet'),
        React.createElement('p', null, 'Start exploring events and register for your first event!')
      )
  );
};

export default Dashboard;